import { useHistory, useRouteMatch } from 'react-router';

import { SUPPORT_PATH } from '../constants';

const routePathMap: Record<string, string> = {
  '/photo-shoot/:venueId': SUPPORT_PATH,
  '/experience/search': '/experience' + SUPPORT_PATH,
};

const getSupportRouteFromUrl = (url: string) => {
  // We just take the first 3 segments because
  // support routes are configured to be at most 3 segments
  // before the support segment: /:one/:two/:three/support
  return '/' + url.split('/').filter(Boolean).slice(0, 3).join('/') + SUPPORT_PATH;
};

export const useRedirectToSupportPage = () => {
  const { url, path } = useRouteMatch();
  const history = useHistory();

  const isIndex = url === '/';
  const isSupportPage = url.includes(SUPPORT_PATH);

  return () => {
    if (isSupportPage) {
      return;
    }

    if (isIndex) {
      history.push(SUPPORT_PATH);
      return;
    }

    if (path in routePathMap) {
      history.push(routePathMap[path]);
      return;
    }

    history.push(getSupportRouteFromUrl(url));
  };
};
